import MainAdminPeople from "./MainAdminPeople";

export default MainAdminPeople;
